<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Summary">
    <section class="summary-section" *ngIf="selectedIndex === 0">
      <app-patient-summary></app-patient-summary>
    </section>
    <section class="appointments-section" *ngIf="selectedIndex === 0">
      <app-appointments-list></app-appointments-list>
    </section>
  </mat-tab>
  <mat-tab label="Account History">
    <section class="account-section" *ngIf="selectedIndex === 1">
      <app-account-history></app-account-history>
    </section>
  </mat-tab>
  <mat-tab label="Treatment Plans">
    <section class="treatment-section" *ngIf="selectedIndex === 2">
      <app-treatment-plans></app-treatment-plans>
    </section>
  </mat-tab>
  <mat-tab label="Insurance Information">
    <section class="insurance-section" *ngIf="selectedIndex === 3">
      <app-insurance-information></app-insurance-information>
    </section>
  </mat-tab>
</mat-tab-group>
